import React, { useMemo, useState } from "react";
import "./big-event.css";

export default function Permissions() {
  const events = useMemo(
    () => [
      { id: "bb-slc-2025", name: "Breaking Barriers — Salt Lake City" },
      { id: "naol-aug", name: "New Art of Living — August Tour" },
    ],
    []
  );

  const [selectedEvent, setSelectedEvent] = useState(events[0].id);
  const [email, setEmail] = useState("");
  const [canView, setCanView] = useState(true);
  const [canEdit, setCanEdit] = useState(false);
  const [canCheckin, setCanCheckin] = useState(true);

  const [shares, setShares] = useState([
    {
      id: "u1",
      email: "teammate@wb.com",
      eventId: "bb-slc-2025",
      canView: true,
      canEdit: true,
      canCheckin: true,
    },
  ]);

  const addShare = () => {
    if (!email) return;
    setShares((s) => [
      ...s,
      {
        id: Math.random().toString(36).slice(2),
        email,
        eventId: selectedEvent,
        canView,
        canEdit,
        canCheckin,
      },
    ]);
    setEmail("");
  };

  const removeShare = (id) => setShares((s) => s.filter((x) => x.id !== id));

  const eventById = (id) => events.find((e) => e.id === id)?.name || id;

  return (
    <div className="be-wrap">
      <div className="be-header">
        <div>
          <h2 className="be-title">Permissions</h2>
          <p className="be-subtitle">
            Grant teammates access to view, edit, or help with event check-ins.
          </p>
        </div>
      </div>

      <div className="be-card" style={{ padding: 14 }}>
        <div className="grid-2">
          <div className="field">
            <label className="field-label">Event</label>
            <select
              className="input"
              value={selectedEvent}
              onChange={(e) => setSelectedEvent(e.target.value)}
            >
              {events.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name}
                </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label className="field-label">User Email</label>
            <input
              className="input"
              placeholder="name@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div
          className="be-row"
          style={{ marginTop: 10, justifyContent: "space-between" }}
        >
          <div className="action-row">
            <label className="checkbox-inline">
              <input
                type="checkbox"
                checked={canView}
                onChange={(e) => setCanView(e.target.checked)}
              />
              Can view
            </label>
            <label className="checkbox-inline">
              <input
                type="checkbox"
                checked={canEdit}
                onChange={(e) => setCanEdit(e.target.checked)}
              />
              Can edit
            </label>
            <label className="checkbox-inline">
              <input
                type="checkbox"
                checked={canCheckin}
                onChange={(e) => setCanCheckin(e.target.checked)}
              />
              Can access Check-in
            </label>
          </div>

          <button className="gold-button" onClick={addShare}>
            Add permission
          </button>
        </div>
      </div>

      <div className="be-card">
        <div className="be-table-wrap">
          <table className="be-table compact">
            <thead>
              <tr>
                <th style={{ width: 280 }}>User</th>
                <th>Event</th>
                <th>View</th>
                <th>Edit</th>
                <th>Check-in</th>
                <th style={{ width: 120, textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {shares.map((s) => (
                <tr key={s.id}>
                  <td>
                    <div className="two-line">
                      <span>{s.email}</span>
                      <span className="muted small">Invited</span>
                    </div>
                  </td>
                  <td>{eventById(s.eventId)}</td>
                  <td>{s.canView ? "✅" : "—"}</td>
                  <td>{s.canEdit ? "✅" : "—"}</td>
                  <td>{s.canCheckin ? "✅" : "—"}</td>
                  <td style={{ textAlign: "right" }}>
                    <button
                      className="btn subtle danger"
                      onClick={() => removeShare(s.id)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
              {shares.length === 0 && (
                <tr>
                  <td
                    colSpan={6}
                    className="muted small"
                    style={{ padding: 14 }}
                  >
                    No permissions yet. Add teammates above.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
